var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscriptionPackage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19369_55477)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6641 2.5H3.33073C2.41406 2.5 1.66406 3.25 1.66406 4.16667V15.8333C1.66406 16.75 2.41406 17.5 3.33073 17.5H16.6641C17.5807 17.5 18.3307 16.75 18.3307 15.8333V4.16667C18.3307 3.25 17.5807 2.5 16.6641 2.5ZM16.6641 15.8333H3.33073V4.16667H16.6641V15.8333Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.175 8.68333L14.9917 7.5L12.35 10.1417L11.175 8.95833L10 10.1333L12.35 12.5L16.175 8.68333Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33073 5.8335H4.16406V7.50016H8.33073V5.8335Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33073 9.1665H4.16406V10.8332H8.33073V9.1665Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33073 12.5H4.16406V14.1667H8.33073V12.5Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19369_55477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionPackage);
export default __webpack_public_path__ + "static/media/subscription_package.517e37671ad9e609f17fb737e48132c9.svg";
export { ForwardRef as ReactComponent };